import { render, staticRenderFns } from "./collectionStatementList.vue?vue&type=template&id=7c3dea74&scoped=true"
import script from "./collectionStatementList.vue?vue&type=script&lang=js"
export * from "./collectionStatementList.vue?vue&type=script&lang=js"
import style0 from "./collectionStatementList.vue?vue&type=style&index=0&id=7c3dea74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3dea74",
  null
  
)

export default component.exports